// src/components/BottomNavBar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
// The incorrect icon has been replaced with LuChartArea
import { LuLayoutDashboard, LuArrowRightLeft, LuSlidersHorizontal, LuUserRound, LuChartArea } from "react-icons/lu";

const BottomNavBar = () => {
  const activeLinkStyle = { color: '#3b82f6' };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-1px_4px_rgba(0,0,0,0.1)] md:hidden">
      <div className="flex justify-around max-w-lg mx-auto"> 
        <NavLink to="/" className="flex flex-col items-center justify-center p-3 text-gray-500" style={({ isActive }) => isActive ? activeLinkStyle : undefined}>
          <LuLayoutDashboard size={24} />
          <span className="text-xs">Dashboard</span>
        </NavLink>
        <NavLink to="/trades" className="flex flex-col items-center justify-center p-3 text-gray-500" style={({ isActive }) => isActive ? activeLinkStyle : undefined}>
          <LuArrowRightLeft size={24} />
          <span className="text-xs">Trades</span>
        </NavLink>
        <NavLink to="/brokers" className="flex flex-col items-center justify-center p-3 text-gray-500" style={({ isActive }) => isActive ? activeLinkStyle : undefined}>
          <LuSlidersHorizontal size={24} />
          <span className="text-xs">Brokers</span>
        </NavLink>

        {/* Using the new, correct icon here */}
        <NavLink to="/analytics" className="flex flex-col items-center justify-center p-3 text-gray-500" style={({ isActive }) => isActive ? activeLinkStyle : undefined}>
          <LuChartArea size={24} />
          <span className="text-xs">Analytics</span>
        </NavLink>

        <NavLink to="/settings" className="flex flex-col items-center justify-center p-3 text-gray-500" style={({ isActive }) => isActive ? activeLinkStyle : undefined}>
          <LuUserRound size={24} />
          <span className="text-xs">Account</span>
        </NavLink>
      </div>
    </div>
  );
};

export default BottomNavBar;